class Config {
    static get API_URL() {
        return "https://api-dv2ibtctga-uc.a.run.app";
    }
}

export default Config;